import ShButton from '@/components/Helpers/ShButton';

// @vue/component
export default {
  name: 'AddNewAgentForm',

  components: {
    ShButton,
  },

  props: {
    numberToBeAssigned: {
      type: Object,
      default: () => ({}),
    },
    widgetId: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      agentName: null,
      agentNumber: null,
      agentExternalName: 'Konsultant',
    };
  },

  computed: {
    availableNumbersList() {
      return this.$store.getters['numbers/list'].filter(number => !number.assigned_to_agent_id && number.is_verified);
    },
    isLoading() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'agents/create',
        'numbers/getList',
      ]);
    },
  },

  mounted() {
    this.agentNumber = this.numberToBeAssigned.id;
  },

  methods: {
    handleCancel() {
      this.agentName = null;
      this.agentNumber = null;
      this.agentExternalName = null;
      this.$emit('closeModal');
    },
    async handleAddNewAgent() {
      const params = {
        name: this.agentName,
        external_name: this.agentExternalName,
        number_id: this.agentNumber,
      };
      const newAgent = await this.$store.dispatch('agents/create', params);

      if (newAgent) {
        await this.$store.dispatch('numbers/getList');
        await this.$store.dispatch('agents/getList');
        if (this.numberToBeAssigned.isConfigModal && this.widgetId) {
          const paramsToAssign = {
            id: this.widgetId,
            agent_id: newAgent,
          };
          await this.$store.dispatch('widgets/assignAgent', paramsToAssign);
          await this.$store.dispatch('widgets/toggleWidgetActivity', {
            id: this.widgetId,
            isActive: true,
          });
          await this.$store.dispatch('widgets/getList');
        }
        this.$emit('handleAddNewAgent');
        this.$emit('closeModal');
        this.$notify.success({
          title: 'Dodanie Konsultanta',
          message: `Dodano nowego Konsultanta: ${this.agentName}`,
          customClass: 'callmeweb-notification',
        });
        this.agentName = null;
        this.agentNumber = null;
      }
    },
  },
};
